import React from 'react';
import styled from 'styled-components';
import { FlexBox, FlexRow, useMatchMedia } from '@make-software/cspr-ui';
import AdsBanner from './ads-banner';

const BannerWrapper = styled(FlexBox)(({ theme }) => ({
  width: '100%',
}));

const HomeBannerWrapper = styled(BannerWrapper)(({ theme }) =>
  theme.withMedia({
    margin: ['16px 0 0 0', '24px 0 8px', '0'],
  })
);

const DetailsBannerWrapper = styled(BannerWrapper)(({ theme }) => ({
  margin: '24px 0',
}));

export const HomeAdsBanner = ({ screenType }: { screenType?: string }) => {
  const showBannerByScreenType = () => {
    switch (screenType) {
      case 'mobile':
        return (
          <HomeBannerWrapper justify={'center'}>
            <AdsBanner screenType={screenType} />
          </HomeBannerWrapper>
        );
      case 'tablet':
        return (
          <HomeBannerWrapper justify={'center'}>
            <AdsBanner screenType={screenType} />
          </HomeBannerWrapper>
        );
      default:
        return (
          <FlexRow>
            <AdsBanner screenType={screenType} />
          </FlexRow>
        );
    }
  };
  return showBannerByScreenType();
};

export const DetailsAdsBanner = () => {
  const screenType = useMatchMedia(['mobile', 'tablet', 'tablet'], []);
  return (
    <DetailsBannerWrapper justify={'center'}>
      <AdsBanner screenType={screenType} />
    </DetailsBannerWrapper>
  );
};
